import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import * as reducks from '../../../reducks'
import history from '../../../lib/history'
import routes from '../../../config/routes'
import ClickOutside from '../ClickOutside/ClickOutside'
import Avatar from '../Avatar/Avatar'
import Text from '../Text/Text'

import LoadingBounce from '../LoadingBounce/LoadingBounce'
import styles from './searchDropdown.module.scss'

function SearchDropdown({ visible, searchText }) {
  if (!visible) return null

  const store = useSelector((state) => state.searchReducer)

  const dispatch = useDispatch()

  const handleDropdown = () => {
    dispatch(reducks.resources.search.actions.clearSearch())
  }

  const handleViewMore = (type) => {
    dispatch(reducks.resources.search.actions.clearSearch())

    const searchURL =
      type === 'wallet'
        ? `${routes.walletSearch.generate(searchText)}`
        : `${routes.contentSearch.generate(searchText)}`

    history.push(searchURL)
  }

  const handleClickItem = (id, type) => {
    history.push(
      type === 'wallet'
        ? routes.extract.generate(id)
        : routes.contentDetail.generate(id)
    )
    dispatch(reducks.resources.search.actions.clearSearch())
  }

  const {
    content: { wallet, knowledgeBases },
    fetching
  } = store

  return (
    <ClickOutside onClickOutside={handleDropdown}>
      <div className={styles.dropdown}>
        <div className={styles.elements}>
          <div className={styles.wallet}>
            <div className={styles.header}>
              <Text
                color="gray"
                variation="darkest"
                size="xs"
                value="Clientes"
                bold
              />
              {wallet.length > 0 && (
                <div
                  className={styles.viewMore}
                  onClick={() => handleViewMore('wallet')}
                >
                  <Text
                    color="gray"
                    variation="darkest"
                    size="xs"
                    value="ver todos"
                  />
                </div>
              )}
            </div>
            <div className={styles.loading}>
              {fetching && <LoadingBounce />}
            </div>
            <div className={styles.items}>
              {!fetching &&
                wallet.slice(0, 4).map((item) => (
                  <div
                    className={styles.item}
                    onClick={() => handleClickItem(item.walletCode, 'wallet')}
                    key={item.id}
                  >
                    <Avatar title={item.nameFantasy} size="small" />

                    <div className={styles.info}>
                      <Text
                        color="gray"
                        variation="dark"
                        size="xs"
                        value={item.nameFantasy}
                        bold
                      />

                      <Text
                        color="gray"
                        size="xxs"
                        value={`${item.groupName || 'N/A'} - ${item.tabNumber}`}
                      />
                    </div>
                  </div>
                ))}
              {!fetching && wallet.length === 0 && (
                <div className={styles.item}>
                  <Text
                    color="gray"
                    variation="dark"
                    size="xs"
                    value="Sem resultados"
                    margin="15px 0 0"
                  />
                </div>
              )}
            </div>
          </div>

          <div className={styles.hr} />

          <div className={styles.wallet}>
            <div className={styles.header}>
              <Text
                color="gray"
                variation="darkest"
                size="xs"
                value="Conteúdos"
                bold
              />
              {knowledgeBases.length > 0 && (
                <div className={styles.viewMore} onClick={handleViewMore}>
                  <Text
                    color="gray"
                    variation="darkest"
                    size="xs"
                    value="ver todos"
                  />
                </div>
              )}
            </div>
            <div className={styles.loading}>
              {fetching && <LoadingBounce />}
            </div>
            <div className={styles.items}>
              {!fetching &&
                knowledgeBases.slice(0, 2).map((item) => (
                  <div
                    className={styles.item}
                    onClick={() => handleClickItem(item.id)}
                    key={item.id}
                  >
                    <Avatar title={item.title} size="small" />

                    <div className={styles.info}>
                      <Text
                        color="gray"
                        variation="dark"
                        size="xs"
                        value={item.title}
                        bold
                      />

                      <Text
                        color="gray"
                        size="xxs"
                        value={item.category.name}
                      />
                    </div>
                  </div>
                ))}
              {!fetching && knowledgeBases.length === 0 && (
                <div className={styles.item}>
                  <Text
                    color="gray"
                    variation="dark"
                    size="xs"
                    value="Sem resultados"
                    margin="15px 0 0"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </ClickOutside>
  )
}

SearchDropdown.defaultProps = {
  visible: false,
  searchText: null
}

SearchDropdown.propTypes = {
  visible: PropTypes.bool,
  searchText: PropTypes.string
}

export default SearchDropdown
